import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import DashboardLayout from "@/layouts/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Integrations from "@/pages/Integrations";
import TrustBoundaries from "@/pages/TrustBoundaries";
import Memory from "@/pages/Memory";
import ActivityLog from "@/pages/ActivityLog";
import ScheduledTasks from "@/pages/ScheduledTasks";
import Approvals from "@/pages/Approvals";
import Conversation from "@/pages/Conversation";
import Setup from "@/pages/Setup";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Status from "@/pages/Status";
import ErrorBoundary from "@/components/ErrorBoundary";
import "@/App.css";

const TOAST_OPTS = {
  style: { background: "#1c1917", border: "1px solid #292524", color: "#fafaf9", borderRadius: 0 }
};

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0c0a09] text-stone-500 font-mono text-xs uppercase tracking-widest">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppInner() {
  const location = useLocation();
  useEffect(() => { document.title = "Copilot — Executive Assistant"; }, []);
  // Synchronous session_id detection to prevent race condition
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/status" element={<Status />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route element={<Protected><DashboardLayout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/conversation" element={<Conversation />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/trust" element={<TrustBoundaries />} />
        <Route path="/memory" element={<Memory />} />
        <Route path="/activity" element={<ActivityLog />} />
        <Route path="/tasks" element={<ScheduledTasks />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/setup" element={<Setup />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <div className="App grain">
        <BrowserRouter>
          <AuthProvider>
            <AppInner />
          </AuthProvider>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={TOAST_OPTS} />
      </div>
    </ErrorBoundary>
  );
}
